// Remove when REBRAND_ENABLED is flipped to true.
import { rebrandPreviewEnabled } from "./rebrandPreview";

const REBRAND_ENABLED = false;

const ENABLED = REBRAND_ENABLED || rebrandPreviewEnabled();

export const rebrandEnabled = (): boolean => ENABLED;
